import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  NgZone,
  OnDestroy,
  OnInit
} from '@angular/core';
import {BehaviorSubject, Subject, takeUntil} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AttachmentAudio, IMessengerConnector } from '../../../../types/all.type';
import { GsPlayerService, PlayerStreamState } from 'gs-player';
import { AllService } from '../../../../services/all.service';
import { MusicPlayerService } from '../../../../services/music-player.service';


@Component({
  selector: 'app-message-player',
  templateUrl: './message-player.component.html',
  styleUrls: ['./message-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessagePlayerComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  @Input() Service: IMessengerConnector;
  @Input() attachment: AttachmentAudio;
  @Input() reverse: boolean;
  isLoading: boolean;
  state: PlayerStreamState;
  public timeElapsed: BehaviorSubject<string> = new BehaviorSubject('00:00');
  public playing: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public timeRemaining: BehaviorSubject<string> = new BehaviorSubject('-00:00');
  public percentElapsed: BehaviorSubject<number> = new BehaviorSubject(0);
  public percentLoaded: BehaviorSubject<number> = new BehaviorSubject(0);
  public playerStatus: BehaviorSubject<string> = new BehaviorSubject('paused');

  constructor(
    public gsPlayer: GsPlayerService,
    public musicPlayerService: MusicPlayerService,
    public allService: AllService,
    private http: HttpClient,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.gsPlayer.getState().subscribe((state) => {
      const currentFile = this.musicPlayerService.wrapPlayer?.currentFile;
      // log(state, currentFile);
      const file = <any>currentFile?.file;
      if (file?.file_id === this.attachment.file_id) {
        this.state = state;
        if (this.playing.value != this.state.playing) {
          this.playing.next(this.state.playing);
        }
        if (this.state.playing) {
          this.isLoading = false;
        }
        this.timeElapsed.next(state.readableCurrentTime);
        this.timeRemaining.next(state.readableDuration);
        this.setPercentElapsed(state.duration, state.currentTime);
      } else {
        this.playing.next(false);
        this.timeElapsed.next('00:00');
        this.timeRemaining.next('-00:00');
        this.percentElapsed.next(0);
      }

      this.cd.detectChanges();
    });
  }
  onRewind() {
    this.musicPlayerService.wrapPlayer.next();
  }
  onForward() {
    this.musicPlayerService.wrapPlayer.previous();
  }
  onSeekAudio(e) {}
  /**
   * The method to play audio
   */
  public playAudio(): void {
    this.isLoading = true;
    this.playing.next(true);
    this.cd.detectChanges();
    if (!this.attachment?.file_uri) {
        this.Service.loadAudio$(this.attachment).pipe(takeUntil(this.destroy$)).subscribe((result) => {
          // this.isLoading = false;
          this.musicPlayerService.addPlayList(this.attachment);
        })
    } else {
      this.musicPlayerService.addPlayList(this.attachment);
    }
  }

  /**
   * The method to pause audio
   */
  public pauseAudio(): void {
    this.gsPlayer.pause();
    this.cd.detectChanges();
  }
  /**
   * Convenience method to toggle the audio between playing and paused
   */
  public toggleAudio(): void {
    this.musicPlayerService.wrapPlayer.playPause();
  }

  private setPercentElapsed(d: number, ct: number): void {
    this.percentElapsed.next(Math.floor((100 / d) * ct) || 0);
  }
  loadImageAttachmentError(event, attachment) {
    if (attachment.thumb) {
      attachment.thumb.file_uri = undefined;
      attachment.thumb.file_uri_error = true;
      this.cd.detectChanges();
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
